// extracted by mini-css-extract-plugin
export var DMSans = "Recruit-module--DMSans--8fdd8";
export var companyImages = "Recruit-module--companyImages--2ed2d";
export var paymentImage = "Recruit-module--paymentImage--8ab8b";
export var root = "Recruit-module--root--029a7";
export var techList = "Recruit-module--techList--a38cd";
export var techListHeading = "Recruit-module--techListHeading--71fc3";
export var testimonialContainer = "Recruit-module--testimonialContainer--dcff8";
export var testimonialOwner = "Recruit-module--testimonialOwner--79e2c";